/**
 * @generated SignedSource<<8c13ea959c633954421e2daac226cdd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MigrateTrelloDataInput = {
  token: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type migrateTrelloDataMutation$variables = {
  input: MigrateTrelloDataInput;
};
export type migrateTrelloDataMutation$data = {
  readonly migrateTrelloData: {
    readonly success: boolean | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type migrateTrelloDataMutation = {
  variables: migrateTrelloDataMutation$variables;
  response: migrateTrelloDataMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MigrateTrelloDataPayload",
    "kind": "LinkedField",
    "name": "migrateTrelloData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "migrateTrelloDataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "migrateTrelloDataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "408959a187eea6e52ff097c95174fb84",
    "id": null,
    "metadata": {},
    "name": "migrateTrelloDataMutation",
    "operationKind": "mutation",
    "text": "mutation migrateTrelloDataMutation(\n  $input: MigrateTrelloDataInput!\n) {\n  migrateTrelloData(input: $input) {\n    success\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "7dcc7698f60f49ddcb9ebd886cc0b98e";

export default node;
